export default {"src":"/_next/static/media/popular.7096407e.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};